import script from "./LoginMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginMain.vue?vue&type=script&setup=true&lang=ts"

import "./LoginMain.vue?vue&type=style&index=0&id=f1e935ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1e935ba"]])

export default __exports__